module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [(_vm.showMiniMenu || !_vm.collapsed) ? _c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width' + ' ' + _vm.stageClass,
    attrs: {
      "span": 10,
      "title": _vm.versionInfo(),
      "i": ""
    }
  }, [_c('img', {
    staticStyle: {
      "margin-left": "-10px",
      "height": "35px",
      "width": "35px",
      "border-radius": "2px"
    },
    attrs: {
      "src": require("../../static/img/tuilogo.png")
    }
  }), _vm._v(" "), _vm._v("\n\t\t\t\t" + _vm._s(_vm.collapsed ? '' : "Tui-WRD-Services" + this.stageSubtitle) + "\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "xclick.prevent": "collapse"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "-10px",
      "margin-top": "2px",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-menu",
    staticStyle: {
      "font-size": "20px"
    }
  })])])])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": this.sysUserAvatar
    }
  }), _vm._v(" " + _vm._s(this.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.openPage('/shownews')
      }
    }
  }, [_vm._v("News")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.openPage('/profile')
      }
    }
  }, [_vm._v("Profile")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("Logout")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [(_vm.showMiniMenu || !_vm.collapsed) ? _c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded',
    attrs: {
      "id": "sidemenu"
    }
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_c('el-menu-item', {
    staticClass: "topitem",
    attrs: {
      "index": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openPage('/main')
      }
    }
  }, [_c('li', {
    staticClass: "el-icon-s-home"
  }), _vm._v(" Home\n          ")]), _vm._v(" "), _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden && _vm.canUse(item)) ? [(!item.leaf && _vm.canUse(item)) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name) + "\n              ")]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden && _vm.canUse(child)) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name) + "\n              ")]) : _vm._e()
    })], 2) : _vm._e()] : _vm._e()
  }), _vm._v(" "), _c('el-menu-item', {
    staticClass: "topitem",
    attrs: {
      "index": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openPage('/shownews')
      }
    }
  }, [_c('li', {
    staticClass: "el-icon-info"
  }), _vm._v(" News & Messages")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "topitem",
    attrs: {
      "index": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_c('li', {
    staticClass: "el-icon-platform-eleme"
  }), _vm._v(" Logout")])], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf && _vm.canUse(item)) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden && _vm.canUse(child)) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "10px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" " + _vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0566967c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 630
// module chunks = 1